import { Action } from '@ngrx/store';
import {ActivateLicenseModel, ActivateLicenseParams} from '../activate-license.model';

export enum ActivateLicenseActionTypes {
  LoadActivateLicenses = '[ActivateLicense] Load ActivateLicenses',
  GetActivateLicenses = '[ActivateLicense] Get ActivateLicenses',
  ClearCheckLicenses = '[ActivateLicense] Clear ActivateLicenses',
}

export class LoadActivateLicenses implements Action {
  readonly type = ActivateLicenseActionTypes.LoadActivateLicenses;
  constructor(public payload: ActivateLicenseModel) {}
}

export class GetActivateLicenses implements Action {
  readonly type = ActivateLicenseActionTypes.GetActivateLicenses;
  constructor(public payload: ActivateLicenseParams) {}
}

export class ClearActivateLicense implements Action {
  readonly type = ActivateLicenseActionTypes.ClearCheckLicenses;
}

export type ActivateLicenseActions = LoadActivateLicenses
  | GetActivateLicenses
  | ClearActivateLicense;
